import {
    IC_SET_MESSAGE,
    IC_UNSET_MESSAGE,
    IC_UNSET_ALL_MESSAGES
} from '../constants';
import {IntercomMessageType} from '~/frontend/src/reducers/intercom';


export type SetMessageAction = {
    type : typeof IC_SET_MESSAGE;
    panelKey : string;
    messageType : IntercomMessageType;
    messageKey : string;
    message : any;
}

/**
 * @memberOf! Actions
 *
 * @param {String} panelKey
 * @param {IntercomMessageType} messageType
 * @param {String} messageKey
 * @param {Object} message
 *
 * @return {SetMessageAction}
 */
export const setMessage = ( panelKey : string, messageType : IntercomMessageType, messageKey : string, message : any ) : SetMessageAction => {
    return {
        type: IC_SET_MESSAGE,
        panelKey,
        messageType,
        messageKey,
        message
    };
}
export type SetMessage = typeof setMessage;
export type MsgParams = Parameters<SetMessage>;


export type UnsetMessageAction = {
    type : typeof IC_UNSET_MESSAGE;
    panelKey : string;
    messageType : IntercomMessageType;
    messageKey : string;
}

/**
 * @memberOf! Actions
 *
 * @param {String} panelKey
 * @param {String} messageType
 * @param {String} messageKey
 *
 * @return {UnsetMessageAction}
 */
export const unsetMessage = ( panelKey : string, messageType : IntercomMessageType, messageKey : string ) : UnsetMessageAction => {
    return {
        type: IC_UNSET_MESSAGE,
        panelKey,
        messageType,
        messageKey
    };
}
export type UnsetMessage = typeof unsetMessage;


export type UnsetAllMessagesAction = {
    type : typeof IC_UNSET_ALL_MESSAGES;
    panelKey : string;
}

/**
 * @memberOf! Actions
 *
 * @param {String} panelKey
 *
 * @return {unsetAllMessages}
 */
export const unsetAllMessages = ( panelKey : string ) : UnsetAllMessagesAction => {
    return {
        type: IC_UNSET_ALL_MESSAGES,
        panelKey
    };
}
export type UnsetAllMessages = typeof unsetAllMessages;
